import React from 'react'
import { Dropdown } from 'react-bootstrap'

export default function FastMenu() {
    return (
        <div className="d-flex align-items-start justify-content-between py-4 pb-3 border-bottom">
            <div className="d-flex align-items-center  ">

                <div className="d-flex align-items-center">
                    <span className="text-uppercase text-light text-small ">speed</span>
                </div>
                <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic" className='btn-faded px-3 ms-2'>
                        Standard
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        <Dropdown.Item href="#/action-1">Fast</Dropdown.Item>
                        <Dropdown.Item href="#/action-2">Instant</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
            <div className="d-flex align-items-center">
                <span className="text-uppercase text-faded text-small ">Deadline</span>
                <span className='harvest harvest-inp ms-1'>
                    <input type="tel" className=" text-uppercase text-faded-3 ms-2" defaultValue={"20"} />
                    <span >Mins</span>
                </span>
            </div>
        </div>
    )
}
